import { __awaiter } from "tslib";
import Vue from 'vue';
import * as echarts from 'echarts';
import { AsideModes } from '@/components/pages/spotPage/trade/interfaces';
import BASE_CONSTANTS from '@/constants/baseConstants';
import { getMarketPairs, adductionToStep } from '@/components/pages/spotPage/trade/helpers';
import buyWidget from './components/buy-widget/index.vue';
import sellWidget from './components/sell-widget/index.vue';
import _ from 'lodash';
import { declOfNum } from '@/utils/numbers';
import { mapGetters } from 'vuex';
import DoExtendedKyc from './../../../kyc-plugs/DoExtendedKyc.vue';
let chartInstance;
const debouncedUpdateChartData = _.debounce(updateChartData, 400);
function updateChartData() {
    if (!chartInstance)
        return;
    const charDataElements = chartInstance === null || chartInstance === void 0 ? void 0 : chartInstance._model.option.series[0].data.map((el) => {
        el.label.position = this.maw(1200) ? 'inner' : 'outer';
        return el;
    });
    chartInstance.setOption({
        series: {
            data: charDataElements,
            labelLine: {
                show: !this.maw(1200)
            }
        }
    });
    chartInstance.resize();
}
const getChartOptions = (vm, viewPortWidth) => {
    const normalizedData = vm.asideWalletData.items
        .sort((a, b) => a.value - b.value)
        .map((item) => {
        const fz = item.value * 18 / 100;
        const position = vm.maw(1200) ? 'inner' : 'outer';
        const result = {
            name: item.name,
            value: parseFloat(item.value.toFixed(4)),
            itemStyle: {},
            label: {
                position,
                rotate: false,
                fontSize: fz < 12 ? 12 : fz,
                color: '#FFFFFF'
            }
        };
        result.itemStyle.color = vm.$color(vm.getColor('ACCENT.BLUE_DARK_1')).lighten((100 - item.value) / 100).hex();
        return result;
    });
    return {
        tooltip: {
            valueFormatter: (value) => (+value).toFixed(2) + '%'
        },
        series: [
            {
                name: vm.$t('spotPage.aside.coin'),
                type: 'pie',
                radius: '60%',
                data: normalizedData,
                labelLine: {
                    show: !vm.maw(1200)
                }
            }
        ]
    };
};
let ALL_PAIRS = [];
function setAssetsFilters(vm) {
    return __awaiter(this, void 0, void 0, function* () {
        let findedPair = ALL_PAIRS.find((item) => item.symbol === vm.tradeData.baseAsset.name + vm.tradeData.quoteAsset.name);
        let symbolPrice = '0';
        let isNotReversed = true;
        if (!findedPair) {
            findedPair = ALL_PAIRS.find((item) => item.symbol === vm.tradeData.quoteAsset.name + vm.tradeData.baseAsset.name);
            isNotReversed = false;
        }
        vm.$emit('onChangeSelectedPairSymbol', findedPair.symbol);
        vm.tradeData.isNotReversedPair = isNotReversed;
        const lotFilter = findedPair.filters.find((item) => item.filterType === 'LOT_SIZE');
        const priceFilter = findedPair.filters.find((item) => item.filterType === 'PRICE_FILTER');
        const notionalFilter = findedPair.filters.find((item) => item.filterType === 'NOTIONAL');
        vm.tradeData.loadingError = false;
        vm.tradeData.loading = true;
        const symbolPriceResponse = yield vm.services.binance.getSymbolPrice(null, findedPair.symbol);
        if (symbolPriceResponse.success) {
            symbolPrice = symbolPriceResponse.data.price;
        }
        else {
            vm.tradeData.loadingError = true;
        }
        vm.tradeData.loading = false;
        vm.tradeData.currentSymbolPrice = symbolPrice;
        if (isNotReversed) {
            vm.tradeData.baseAsset.min = adductionToStep(((1 / parseFloat(symbolPrice) * parseFloat(notionalFilter.minNotional)) + parseFloat(lotFilter.stepSize)), lotFilter.stepSize);
            vm.tradeData.baseAsset.max = adductionToStep(lotFilter.maxQty, lotFilter.stepSize);
            vm.tradeData.baseAsset.stepSize = adductionToStep(lotFilter.stepSize, lotFilter.stepSize);
            vm.tradeData.baseAsset.quantity = adductionToStep(vm.selectedItems[0].val, lotFilter.stepSize);
            vm.tradeData.quoteAsset.min = adductionToStep((parseFloat(notionalFilter.minNotional) + parseFloat(priceFilter.tickSize)), priceFilter.tickSize);
            vm.tradeData.quoteAsset.max = adductionToStep(vm.selectedQuoteAssetQuantity > 0 ? vm.selectedQuoteAssetQuantity : priceFilter.maxPrice, priceFilter.tickSize);
            vm.tradeData.quoteAsset.stepSize = adductionToStep(priceFilter.tickSize, priceFilter.tickSize);
            vm.tradeData.quoteAsset.quantity = adductionToStep(vm.selectedQuoteAssetQuantity, priceFilter.tickSize);
        }
        else {
            vm.tradeData.baseAsset.min = adductionToStep((parseFloat(notionalFilter.minNotional) + parseFloat(priceFilter.tickSize)), priceFilter.tickSize);
            vm.tradeData.baseAsset.max = adductionToStep(priceFilter.maxPrice, priceFilter.tickSize);
            vm.tradeData.baseAsset.stepSize = adductionToStep(priceFilter.tickSize, priceFilter.tickSize);
            vm.tradeData.baseAsset.quantity = adductionToStep(vm.selectedItems[0].val, priceFilter.tickSize);
            vm.tradeData.quoteAsset.min = adductionToStep(((1 / parseFloat(symbolPrice) * parseFloat(notionalFilter.minNotional)) + parseFloat(lotFilter.stepSize)), lotFilter.stepSize);
            vm.tradeData.quoteAsset.max = adductionToStep(vm.selectedQuoteAssetQuantity > 0 ? vm.selectedQuoteAssetQuantity : lotFilter.maxQty, lotFilter.stepSize);
            vm.tradeData.quoteAsset.stepSize = adductionToStep(lotFilter.stepSize, lotFilter.stepSize);
            vm.tradeData.quoteAsset.quantity = adductionToStep(vm.selectedQuoteAssetQuantity, lotFilter.stepSize);
        }
    });
}
let isDependedChangeQuoteAsset = false;
export default Vue.extend({
    name: 'spotAside',
    props: {
        asideMode: {
            type: String,
            required: true
        },
        asideWalletData: {
            type: Object,
            required: true
        },
        selectedItems: {
            type: Array,
            required: true
        },
        selectedFolders: {
            type: Array,
            required: true
        },
        BTCUSDTExchange: {
            type: String,
            required: true
        },
        findedPairSymbolMarketPrice: {
            type: String,
            required: true
        },
        selectedQuoteAssetQuantity: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            mode: AsideModes.sell,
            availableQuoteAssetsToSelectedItem: [],
            tradeData: {
                loading: false,
                loadingError: false,
                baseAsset: {
                    name: '',
                    quantity: '',
                    min: '0',
                    max: '0',
                    stepSize: '0.1'
                },
                quoteAsset: {
                    name: '',
                    quantity: '',
                    min: '0',
                    max: '0',
                    stepSize: '0.1'
                },
                currentSymbolPrice: 0,
                isNotReversedPair: true,
                quoteList: []
            },
            tradeUnavailable: false,
            folderEdit: {
                isEdit: false,
                fields: {
                    name: {
                        value: '',
                        rules: [
                            (v) => Boolean(v) || this.$t('spotPage.aside.folderEdit.form.fields.name.rules.required')
                        ]
                    }
                }
            }
        };
    },
    computed: Object.assign(Object.assign({}, mapGetters('user', ['extendedKycStatus'])), { isExtendedFailed() {
            return this.extendedKycStatus !== 'accepted' && this.extendedKycStatus !== null && (this.selectedItems.length > 0 || this.selectedFolders.length > 0);
        }, reducedTradePairs() {
            const vm = this;
            return vm.tradeData.quoteList.map((symbol, index) => { var _a, _b; return ({ value: `${(_b = (_a = vm.selectedItems[0]) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : ''} / ${symbol}`, key: index }); });
        },
        showUnlockBlock() {
            const vm = this;
            if (vm.selectedItems.length) {
                return vm.selectedItems[0].locked;
            }
            else
                return false;
        },
        haveFiat() {
            const vm = this;
            return BASE_CONSTANTS.FIAT_LIST.includes(vm.selectedItems[0].name);
        },
        userCoins() {
            const vm = this;
            return vm.asideWalletData.items.map((item) => item.name);
        } }),
    watch: {
        findedPairSymbolMarketPrice(v) {
            const vm = this;
            vm.tradeData.currentSymbolPrice = parseFloat(v);
        },
        asideMode(v) {
            const vm = this;
            if (v !== vm.mode)
                vm.mode = v;
        },
        asideWalletData: {
            handler() {
                const vm = this;
                if (chartInstance) {
                    chartInstance.setOption(getChartOptions(vm));
                }
            },
            deep: true
        },
        selectedItems: {
            handler(value) {
                const vm = this;
                if (value.length === 1) {
                    vm.tradeData.baseAsset.name = value[0].name;
                    vm.tradeData.baseAsset.quantity = adductionToStep(value[0].val, vm.tradeData.baseAsset.stepSize);
                }
            },
            deep: true
        },
        selectedQuoteAssetQuantity(newValue, oldValue) {
            const vm = this;
            if (newValue !== oldValue) {
                vm.$nextTick(() => {
                    setAssetsFilters(vm);
                });
            }
        },
        'tradeData.baseAsset.name'(v) {
            const vm = this;
            vm.$nextTick(() => {
                isDependedChangeQuoteAsset = true;
                vm.tradeData.quoteList = [];
                const result = ALL_PAIRS
                    .filter((item) => item.baseAsset === v)
                    .map((item) => {
                    return item.quoteAsset;
                }).sort();
                if (result.includes('USDT')) {
                    vm.tradeData.quoteAsset.name = 'USDT';
                }
                else
                    vm.tradeData.quoteAsset.name = result[0];
                vm.tradeData.quoteList = result;
                vm.tradeUnavailable = vm.tradeData.quoteList.length === 0;
                if (!vm.haveFiat && !vm.tradeUnavailable) {
                    setAssetsFilters(vm);
                }
                isDependedChangeQuoteAsset = false;
            });
        },
        'tradeData.quoteAsset.name'(v) {
            const vm = this;
            vm.$emit('onChangeQuoteAsset', v);
            if (!isDependedChangeQuoteAsset) {
                setTimeout(() => {
                    if (!vm.haveFiat && !vm.tradeUnavailable)
                        setAssetsFilters(vm);
                }, 100);
            }
        }
    },
    methods: {
        countTotalFolderCoinsCost(items) {
            const filters = this.$options.filters;
            return filters.formatMoney(filters.formatToCurrency(items.reduce((acc, curr) => {
                acc += parseFloat(curr.valInUSDT);
                return acc;
            }, 0), 'usdt'));
        },
        coinsCaseFormatter: function (value, lang) {
            return lang === 'ru' ? declOfNum(value, ['монету', 'монеты', 'монет']) : declOfNum(value, ['coins', 'coin', 'coins']);
        },
        handleFolderNameEditDone() {
            if (this.folderEdit.fields.name.value !== this.selectedFolders[0].name) {
                this.$emit('onFolderRename', this.folderEdit.fields.name.value, this.selectedFolders[0]);
                this.folderEdit.fields.name.value = '';
            }
            this.folderEdit.isEdit = false;
        },
        reloadTradeData() {
            const vm = this;
            setAssetsFilters(vm);
        }
    },
    beforeDestroy() {
        window.removeEventListener('resize', debouncedUpdateChartData);
    },
    created() {
        const vm = this;
        window.addEventListener('resize', debouncedUpdateChartData.bind(vm));
    },
    mounted() {
        return __awaiter(this, void 0, void 0, function* () {
            const vm = this;
            const chart = vm.$refs.chart;
            if (!chart)
                return;
            chartInstance = echarts.init(chart);
            chartInstance.setOption(getChartOptions(vm));
            getMarketPairs().then((result) => {
                ALL_PAIRS = result;
            });
        });
    },
    components: {
        buyWidget,
        sellWidget,
        DoExtendedKyc
    }
});
